module.exports = __webpack_public_path__ + "static/media/1POLICY24.21943272.jpg";